export const createApprovalLineState = () => ({
  depHeads: [], // 중간결재자 (최대 4명)
  safetyManager: null, // 최종결재자 (1명)
  observer: null, // ✅ 입회자 추가 (1명)
  smId: '', // 최종결재자 ID 연동용
  initialized: false,
  touched: false,
});

export const normalizeApprovalLine = (rows = [], depApproval = []) => {
  const managers = depApproval.flatMap((dep) =>
    (dep.managers || []).map((manager) => ({
      ...manager,
      depCd: dep.depCd,
      depNm: dep.depNmLast || dep.depNm,
    }))
  );

  const depHeads = rows
    .filter((row) => row.approverType === 'INTERMEDIATE')
    .sort((a, b) => (a.no || 0) - (b.no || 0))
    .map((row) => {
      const manager = managers.find((item) => item.id === row.id);
      return {
        depCd: manager?.depCd || '',
        depNm: manager?.depNm || '',
        headId: row.id,
        headNm: manager?.name || '',
        position: manager?.position || '',
        photo: manager?.photo || '',
        no: row.no || 0,
      };
    });

  const finalRow = rows
    .filter((row) => row.approverType === 'FINAL')
    .sort((a, b) => (a.no || 0) - (b.no || 0))[0];
  const finalManager = managers.find((item) => item.id === finalRow?.id);

  const safetyManager = finalRow
    ? {
        depCd: finalManager?.depCd || '',
        depNm: finalManager?.depNm || '',
        smId: finalRow.id,
        smNm: finalManager?.name || '',
        position: finalManager?.position || '',
        photo: finalManager?.photo || '',
        no: finalRow.no || 0,
      }
    : null;

  const observerRow = rows.find((row) => row.approverType === 'WITNESS');
  const obsManager = managers.find((item) => item.id === observerRow?.id);

  const observer = observerRow
    ? {
        depCd: obsManager?.depCd || '',
        depNm: obsManager?.depNm || '',
        id: observerRow.id,
        name: obsManager?.name || '',
        position: obsManager?.position || '',
        photo: obsManager?.photo || '',
      }
    : null;

  return {
    depHeads,
    safetyManager,
    observer,
    smId: safetyManager?.smId || '',
  };
};
